// Language List
export const LANGUAGE_OPTIONS_LIST = {
  en: ' English',
  'zh-Hans': '中文',
  ja: ' 日本語',
  ko: ' 한국어',
  es: ' Español',
  fr: ' Français',
  de: ' Deutsch',
  ru: ' Русский',
  pt: ' Português',
  it: ' Italiano',
  nl: ' Nederlands',
  pl: ' Polski',
  sv: ' Svenska',
  da: ' Dansk',
  no: ' Norsk',
  fi: ' Suomi',
  tr: ' Türkçe',
  ar: ' العربية',
  he: ' עברית',
  hi: ' हिन्दी',
  id: ' Bahasa Indonesia',
  ms: ' Bahasa Melayu',
  th: ' ไทย',
  vi: ' Tiếng Việt',
  my: 'မြန်မာ',
  el: ' Ελληνικά',
  hu: ' Magyar',
  cs: ' Čeština',
  sk: ' Slovenčina',
  uk: ' Українська',
  bg: ' Български',
  ro: ' Română',
  hr: ' Hrvatski',
  sr: ' Српски',
  sl: ' Slovenščina',
  et: ' Eesti',
  lv: ' Latviešu',
  lt: ' Lietuvių',
};

// 兼容处理
export const languageTranslate = (key: string) => {
  if (key === 'zh') return 'zh-Hans';
  return key;
};
